import axios from 'axios';
import { history, store } from '../helpers'
import { logout } from "../actions/authentification";
import { SET_DIALOG } from "../actions/types";

const { dispatch } = store;
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    if (error.response) {
        if (error.response.status === 401) {
            dispatch(logout());
            return history.push('/login')
        }
        // The client was given an error response (5xx, 4xx)
        return dispatch({
            type: SET_DIALOG,
            payload: {
                isOpen: true,
                title: 'Sorry, something went wrong on our end.',
                message1: error.response.data?.content?.message ?? error.message,
                message2: error.response.data?.content?.description ?? 'Please check your data'
            }
        });
    } else if (error.request) {
        // The client never received a response, and the request was never left
        return dispatch({
            type: SET_DIALOG,
            payload: {
                isOpen: true,
                title: 'Oops! Internal Server Error',
                message1: 'Sorry, something went wrong on our end.',
                message2: 'Please contact your administrator'
            }
        });
    } else {
        // Anything else
        return dispatch({
            type: SET_DIALOG,
            payload: {
                isOpen: true,
                title: 'Oops! Internal Server Error',
                message1: error.message,
                message2: 'Please contact your administrator'
            }
        });
    }
    // eslint-disable-next-line no-unreachable
    return Promise.reject(error);
});
export default axiosInstance;